import imageClick from '../../assets/images/clickImage.png'
import backgroundElipses from '../../assets/images/backgroundelipses.png'
import { NewsLetterButton, NewsLetterDiv, NewsLetterTitle, NewsLetterWrapper, ImageClickElement } from './styles'


const NewsLetter = () => {
  return (
    <NewsLetterWrapper style={{
      backgroundImage: `url(${backgroundElipses})`,
      backgroundRepeat: 'no-repeat',
    }}>
      <NewsLetterDiv>
        <NewsLetterTitle>Get Aped with Us!</NewsLetterTitle>
        <NewsLetterButton>Sign up for our newsletter</NewsLetterButton>
        <ImageClickElement src={imageClick} />
      </NewsLetterDiv>
    </NewsLetterWrapper>
  )
};

export default NewsLetter;